import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Header.module.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <header className={styles.header}>
      <div className={styles.logoContainer}>
        <Link to="/" className={styles.logoLink}>
          <h1 className={styles.logoText}>ImageCompressor</h1>
        </Link>
      </div>
      <nav className={`${styles.nav} ${menuOpen ? styles.active : ""}`}>
        <Link
          to="/"
          className={styles.link}
          onClick={() => setMenuOpen(false)}
          style={{ textDecoration: "none" }}
        >
          Home
        </Link>

        {/* Dropdown menu */}
        <div
          className={styles.dropdown}
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
        >
          <button
            className={styles.dropdownButton}
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            Image Convert<span className={styles.arrow}>▼</span>
          </button>
          {dropdownOpen && (
            <div className={styles.dropdownContent}>
              <Link
                to="/image-to-webp"
                className={styles.dropdownLink}
                onClick={() => {
                  setMenuOpen(false);
                  setDropdownOpen(false);
                }}
                style={{ textDecoration: "none" }}
              >
                Image to WebP
              </Link>
              <Link
                to="/image-to-png"
                className={styles.dropdownLink}
                onClick={() => {
                  setMenuOpen(false);
                  setDropdownOpen(false);
                }}
                style={{ textDecoration: "none" }}
              >
                Image to PNG
              </Link>
              <Link
                to="/image-to-jpg"
                className={styles.dropdownLink}
                onClick={() => {
                  setMenuOpen(false);
                  setDropdownOpen(false);
                }}
                style={{ textDecoration: "none" }}
              >
                Image to JPG
              </Link>
              {/* New Batch Processing feature */}
              <Link
                to="/batch-processing"
                className={styles.dropdownLink}
                onClick={() => {
                  setMenuOpen(false);
                  setDropdownOpen(false);
                }}
                style={{ textDecoration: "none" }}
              >
                Bulk Conversion Tool
              </Link>
              <Link
                to="/bulk-compressor"
                className={styles.dropdownLink}
                onClick={() => {
                  setMenuOpen(false);
                  setDropdownOpen(false);
                }}
                style={{ textDecoration: "none" }}
              >
                Bulk Image Compressor
              </Link>
              <Link
                to="/image-crop-compress"
                className={styles.dropdownLink}
                onClick={() => {
                  setMenuOpen(false);
                  setDropdownOpen(false);
                }}
                style={{ textDecoration: "none" }}
              >
                Crop & Compress
              </Link>
            </div>
          )}
        </div>

        <Link
          to="/about"
          className={styles.link}
          onClick={() => setMenuOpen(false)}
          style={{ textDecoration: "none" }}
        >
          About Us
        </Link>
        <Link
          to="/contact"
          className={styles.link}
          onClick={() => setMenuOpen(false)}
          style={{ textDecoration: "none" }}
        >
          Contact Us
        </Link>
      </nav>
      <button
        className={styles.menuButton}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        {menuOpen ? "✕" : "☰"}
      </button>
    </header>
  );
};

export default Header;
